import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { useSession } from "@/hooks/useSession";
import { usePortalUser } from "@/hooks/usePortalUser";
import { buildAppUrl } from "@/lib/url";

export function AdminLoginPage() {
  const navigate = useNavigate();
  const { session, loading } = useSession();
  const { isPortalUser, checking } = usePortalUser(session);

  useEffect(() => {
    if (!loading && !checking && session && isPortalUser) {
      navigate("/admin", { replace: true });
    }
  }, [loading, checking, session, isPortalUser, navigate]);

  async function signInGoogle() {
    const redirectTo = buildAppUrl("/admin");
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo },
    });
    if (error) console.error(error);
  }

  if (loading || (session && checking)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-blue text-brand-gray">
        Loading…
      </div>
    );
  }

  if (session && !checking && !isPortalUser) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-brand-blue px-4 text-center text-brand-gray">
        <p className="font-display text-2xl font-bold">Access not authorised</p>
        <p className="mt-4 max-w-md text-sm text-brand-gray/90">
          {session.user.email} is not registered for portal access. Ask a super user to add you in
          Admin → Users, or insert the appropriate rows into{" "}
          <code className="text-white">portal_access_grants</code> in Supabase.
        </p>
        <button
          type="button"
          onClick={() => void supabase.auth.signOut()}
          className="mt-8 rounded-full bg-brand-maroon px-8 py-3 text-sm font-bold uppercase tracking-wide text-white"
        >
          Sign out
        </button>
        <Link to="/" className="mt-6 text-sm underline">
          Back to site
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-blue px-4">
      <p className="font-display text-2xl font-bold text-brand-gray">Portal sign in</p>
      <p className="mt-3 max-w-sm text-center text-sm text-brand-gray/90">
        Sign in with Google to manage content you are assigned to.
      </p>
      <button
        type="button"
        onClick={() => void signInGoogle()}
        className="mt-8 rounded-full bg-white px-8 py-3 text-sm font-bold uppercase tracking-wide text-brand-blue shadow-md"
      >
        Continue with Google
      </button>
      <Link to="/" className="mt-10 text-sm font-semibold text-brand-gray underline">
        Back to site
      </Link>
    </div>
  );
}
